<script>
    import {
        health, energy, hygiene, culture, smooth,
        iq, loneliness, confidence, stress,
        honesty, optimism, fitness, alcoholism, drugs,
        currentJob,
        modal, getEventsOn, date, upcomingEvent, time, rnd, money, progressTime, days_skipped_work
    } from './stores.js';
    import {get} from "svelte/store";

    let events_today = getEventsOn($date, $upcomingEvent);
    let events_now = events_today.filter(event => event.time === $time);
    console.log(events_now);

    var fail_audio = new Audio("/audio/sad_trombone.mp3");

    let wentToDentist = false;
    let hadMoneyForDentist = false;
    let dentistCost = 0;

    const goToDentist = () => {
        dentistCost = rnd(10, 30);
        if ($money >= dentistCost) {
            hadMoneyForDentist = true;
            $money -= dentistCost;
            $health += 0.3;
            $confidence += 0.1;
            $hygiene += 0.1;
            $smooth += 0.1;
        } else {
            $confidence -= 0.1;
            $smooth -= 0.1;
            fail_audio.play();
        }
        wentToDentist = true;
        progressTime();
    };

    let wentToInterview = false;
    let interviewSuccess = false;

    const goToInterview = (job) => {
        if (job.canApply() && $alcoholism < 0.6 && $drugs < 0.8 && $energy > 0.4 && $hygiene > 0.2) {
            interviewSuccess = true;
            $confidence += 0.2;
            $optimism += 0.2;
            $days_skipped_work = 0;
            $currentJob = job;
        } else {
            $confidence -= 0.05;
            $optimism -= 0.05;
            fail_audio.play();
        }
        $energy -= 0.2;
        wentToInterview = true;
        progressTime();
    };
</script>

<style>
    div {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }
    h1 {
        font-size: 2rem;
        text-align: center;
    }
</style>

<div>
    {#each events_now as event}
        {#if event.hasOwnProperty('job')}
            <h1>
                {event.name}
                {#if event.job.employer.length > 0}
                    <br>at {event.job.employer}
                {/if}
            </h1>
            {#if !wentToInterview}
                <p>You have the job interview today!</p>
                <sl-button on:click={() => goToInterview(event.job)}>Go to the Interview</sl-button>
            {:else}
                {#if interviewSuccess}
                    <sl-alert type="success" open>
                        <sl-icon slot="icon" name="check2-circle"></sl-icon>
                        The interview went well! You got the job!<br>
                        You new average daily salary is <sl-icon src="/img/coin.svg"></sl-icon> {event.job.dailyAvgSalary().toFixed(2)}.
                    </sl-alert>
                {:else}
                    <sl-alert type="danger" open>
                        <sl-icon slot="icon" name="exclamation-octagon"></sl-icon>
                        Unfortunately you got rejected at the interview. Better luck next time.
                    </sl-alert>
                {/if}
            {/if}

        {:else if event.name === 'Dentist'}
            <h1>Dentist appointment</h1>
            {#if !wentToDentist}
                <p>You haven't been to dentist in a while.</p>
                <sl-button on:click={goToDentist}>Go to the Dentist</sl-button>
            {:else}
                {#if hadMoneyForDentist}
                    <sl-alert type="success" open>
                        <sl-icon slot="icon" name="check2-circle"></sl-icon>
                        The dentist charged you <sl-icon src="/img/coin.svg"></sl-icon> {dentistCost.toFixed(2)} for all the dental work. No more tooth ache!
                    </sl-alert>
                {:else}
                    <sl-alert type="danger" open>
                        <sl-icon slot="icon" name="exclamation-octagon"></sl-icon>
                        Unfortunately you didn't have enough money to pay for the dental work.
                    </sl-alert>
                {/if}
            {/if}
        {/if}
    {/each}
</div>
